import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {
  API,
  EMPLOYEE_CATEGORIES,
  VW_UNITS,
  MODAL_MESSAGES
} from '../../shared/constants';


import {
  FormMediaComponent
} from '../../shared/';

import {
  AlertService
} from '../../core/alert/alert.service';

import {
  CheckboxValidators,
  TextValidators
} from '../../core';

// TODO: Move to news.module
import { NewsService } from '../../noticias/shared/news.service';
import { News } from '../shared/news.model';

@Component({
  selector: 'cms-news-form',
  templateUrl: './news-form.component.html',
  providers: [
    NewsService
  ]
})
export class NewsFormComponent implements OnInit {

  @ViewChild(FormMediaComponent) private formMedia: FormMediaComponent;
  medias: Array<any>;
  isMediasDone: boolean;

  title: string;
  entity: any = {
    id: '',
    type: 'news'
  };

  newsForm: FormGroup;
  categoriasFuncionarios: Array<any> = EMPLOYEE_CATEGORIES;
  unidades: Array<any> = VW_UNITS;
  isEditing: boolean;
  isSubmitted: boolean = false;
  isDeleted: boolean = false;
  selectedNews: News = new News();
  allUnitsSelected: boolean = false;
  allCategoriesSelected: boolean = false;

  //Datepicker options:
  minDate: Date = new Date();
  showWeeks: boolean = false;
  dateLabel = '';
  timeLabel = '';
  showDatePicker: boolean = false;
  showTimePicker: boolean = false;
  isSavingData = false;

  constructor (
    private fb: FormBuilder,
    private newsService: NewsService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService
  ){ }

  ngOnInit() {
    this.isEditing = false;
    this.title = 'Notícias / Adicionar Notícia';
    this.isMediasDone = false;

    this.route.data
      .subscribe((data: { news: News }) => {
        if (!this.isAddMode()) {
          this.isEditing = true;
          this.title = 'Notícias / Editar Notícia';
        }

        this.entity.id = data.news._id;
        this.selectedNews = data.news;
        this.medias = data.news.midias;
        this.formMedia.onMediaLoaded(data.news.midias);
        this.isMediasDone = true;
      });

    let date = new Date();
    if (!this.isEditing) {
      this.newsForm = this.fb.group({
        'publishDate' : [date, Validators.required],
        'sendTime' : [date, Validators.required],
        'title' : ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(80)])],
        'units': this.fb.group({
          'vw-anchieta': [false],
          'vw-taubate': [false],
          'vw-sao-carlos': [false],
          'vw-curitiba': [false]
        }, {
          validator: CheckboxValidators.haveOneChecked()
        }),
        'categories': this.fb.group({
          'vw-horist': [false],
          'vw-monthly': [false],
          'vw-executive': [false]
        }, {
          validator: CheckboxValidators.haveOneChecked()
        }),
        'content' : ['',
                    Validators.compose([Validators.required, Validators.minLength(1), TextValidators.maxText(5000)])],
        'isPublished': [false],
        'hasPush': [false],
        'hasCover': [false]
      });
    } else {
      date = (this.selectedNews.publishDate != undefined) ? new Date(this.selectedNews.publishDate) : date;
      this.newsForm = this.fb.group({
        'publishDate' : [date, Validators.required],
        'sendTime' : [date, Validators.required],
        'title' : [this.selectedNews.title,
                  Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(80)])],
        'units': this.fb.group({
          'vw-anchieta': [(this.selectedNews.units.indexOf('vw-anchieta') >= 0) ? true : false],
          'vw-taubate': [(this.selectedNews.units.indexOf('vw-taubate') >= 0) ? true : false],
          'vw-sao-carlos': [(this.selectedNews.units.indexOf('vw-sao-carlos') >= 0) ? true : false],
          'vw-curitiba': [(this.selectedNews.units.indexOf('vw-curitiba') >= 0) ? true : false]
        }, {
          validator: CheckboxValidators.haveOneChecked()
        }),
        'categories': this.fb.group({
          'vw-horist': [(this.selectedNews.categories.indexOf('vw-horist') >= 0) ? true : false],
          'vw-monthly': [(this.selectedNews.categories.indexOf('vw-monthly') >= 0) ? true : false],
          'vw-executive': [(this.selectedNews.categories.indexOf('vw-executive') >= 0) ? true : false]
        }, {
          validator: CheckboxValidators.haveOneChecked()
        }),
        'content' : [this.selectedNews.content,
                    Validators.compose([Validators.required, Validators.minLength(1), TextValidators.maxText(5000)])],
        'isPublished': [this.selectedNews.isPublished],
        'hasPush': [this.selectedNews.hasPush],
        'hasCover': [this.selectedNews.hasCover]
      });
    }
    this.onDateChange(date);
    this.onTimeChange(date);

    // all units checkbox
    if ((this.selectedNews.units.indexOf('vw-anchieta') >= 0) &&
        (this.selectedNews.units.indexOf('vw-taubate') >= 0) &&
        (this.selectedNews.units.indexOf('vw-sao-carlos') >= 0) &&
        (this.selectedNews.units.indexOf('vw-curitiba') >= 0)) {
          this.allUnitsSelected = true;
          document.getElementById("all-units").setAttribute('checked','checked');
        }

    // all categories checkbox
    if ((this.selectedNews.categories.indexOf('vw-horist') >= 0) &&
    (this.selectedNews.categories.indexOf('vw-monthly') >= 0) &&
    (this.selectedNews.categories.indexOf('vw-executive') >= 0)) {
      this.allCategoriesSelected = true;
      document.getElementById("all-categories").setAttribute('checked','checked');
    }
  }

  onDateChange(newValue) {
    this.dateLabel = new Date(newValue).toISOString();
    this.showDatePicker = false;
  }
  onTimeChange(newValue) {
    this.timeLabel = new Date(newValue).toISOString();
  }

  canDeactivate(): Promise<boolean>|boolean {
    if ((this.newsForm.dirty) &&
        !this.isSubmitted) {

      return this.alertService
        .activate()
        .then((response) => {
          if (response) {
            //If is adding a news, so delete it
            if(!this.isEditing && !this.isSubmitted){
              this.deleteTempNews();
            }
          }
          return response;
        });
      // var answer = window.confirm('As mudanças não foram salvas. Tem certeza que gostaria continuar ?');
    } else {
      //If is adding a news, so delete it
      if(!this.isEditing && !this.isSubmitted){
        this.deleteTempNews();
      }
    }

    return true;
  }

  isCheckboxDirty(control, values) {
    let isDirty = false;
    for (let value of values) {
      if (this.newsForm.controls[control]['controls'][value.VALUE]['dirty']) {
        isDirty = true;
        break;
      }
    }

    return isDirty;
  }

  //Add, edit and delete functions
  submitForm(value: any, valid:any) {
    if (value.hasCover && this.medias.length < 1) {
      valid = false;
      let title = 'Tweet do presidente';
      let message = 'Para publicar uma notícia do tipo tweet, adicione pelo menos uma imagem para ser a capa da publicação.';
      let okButton = 'ok';
      let dismiss = '';
      this.alertService.activate(message, title, okButton, dismiss);
    } else {
      this.isSavingData = true;
      var newUnits: String[] = [];
      var newCategories: String[] = [];

      //Get time value to set it to date field.
      value.publishDate.setHours(value.sendTime.getHours());
      value.publishDate.setMinutes(value.sendTime.getMinutes());

      value._id = this.selectedNews._id
      this.unidades.forEach(
        unit =>  (value.units[unit.VALUE])? newUnits.push(unit.VALUE): null
      );
      this.categoriasFuncionarios.forEach(
        category => (value.categories[category.VALUE])? newCategories.push(category.VALUE): null
      );
      value.units = newUnits;
      value.categories = newCategories;
      value.midias = this.deepClone(this.medias);
      value.midias.forEach((midia) => {
        if (midia.base64) {
          delete midia.base64;
        }

        if (midia.frameBase64) {
          delete midia.frameBase64;
        }
      });

      if (this.isEditing) {
        value['_id'] = this.selectedNews._id;
      }

      if (valid) {
        this.newsService
          .updateNews(value)
          .then((res) => {
            let message = MODAL_MESSAGES.ADD.TEXT;
            let title = MODAL_MESSAGES.ADD.TITLE;
            let okText = 'OK';

            if (res.serviceStatus.code <= 0) {
              this.isSubmitted = true;

              if (this.isEditing) {
                message = MODAL_MESSAGES.EDIT.TEXT;
                title = MODAL_MESSAGES.EDIT.TITLE;
              }
            } else {
              this.isSubmitted = false;
              message = MODAL_MESSAGES.ERROR.TEXT;
              title = MODAL_MESSAGES.ERROR.TITLE;
            }

            this.alertService
              .activate(message, title, okText, '')
              .then((response) => {
                if (response) {
                  this.goToList();
                }
              });
            this.isSavingData = false;
          });
      } else {
        this.isSavingData = false;
      }
    }
  }

  deepClone(oldArray: Object[]) {
    let newArray: any = [];
    oldArray.forEach((item) => {
      newArray.push(Object.assign({}, item));
    });
    return newArray;
  }

  askDeleteConfirmation() {
    let message = MODAL_MESSAGES.DELETE.TEXT;
    let title = MODAL_MESSAGES.DELETE.TITLE;

    this.alertService
      .activate(message, title)
      .then((response) => {
        if (response) {
          this.deleteNews();
        }
      });
  }

  deleteNews() {
    this.newsService
      .deleteNews(this.selectedNews._id)
      .then((res) => {
        if (res.serviceStatus.message == 'Success') {
          this.isDeleted = true;
          this.router.navigate(['/news']);
        }
      });
  }

  deleteTempNews() {
    this.newsService
      .deleteNews(this.selectedNews._id)
      .then((res) => {
        if (res.serviceStatus.message == 'Success') {
          this.isDeleted = true;
        }
      });
  }

  goToList() {
    this.router.navigate(['/news']);
  }

  onUpdatedMedia(medias: any[]) {
    this.medias = medias;
    this.isMediasDone = true;
  }

  onAddedMedia(type: string) {
    this.isMediasDone = false;
  }

  onDroppedMedia(type: string) {
    this.newsForm.markAsDirty();
  }

  private isAddMode() {
    return this.route.snapshot.params['id'] === 'new';
  }

  selectAllUnits() {
    const control = <FormArray>this.newsForm.controls['units'];
    if (this.allUnitsSelected == false) {
      this.allUnitsSelected = true;
      control.controls['vw-anchieta'].setValue(true);
      control.controls['vw-taubate'].setValue(true);
      control.controls['vw-sao-carlos'].setValue(true);
      control.controls['vw-curitiba'].setValue(true);
    } else {
      this.allUnitsSelected = false;
      control.controls['vw-anchieta'].setValue(false);
      control.controls['vw-taubate'].setValue(false);
      control.controls['vw-sao-carlos'].setValue(false);
      control.controls['vw-curitiba'].setValue(false);
    }
  }

  selectAllCategories() {
    const control = <FormArray>this.newsForm.controls['categories'];
    if (this.allCategoriesSelected == false) {
      this.allCategoriesSelected = true;
      control.controls['vw-horist'].setValue(true);
      control.controls['vw-monthly'].setValue(true);
      control.controls['vw-executive'].setValue(true);
    } else {
      this.allCategoriesSelected = false;
      control.controls['vw-horist'].setValue(false);
      control.controls['vw-monthly'].setValue(false);
      control.controls['vw-executive'].setValue(false);
    }
  }

  alertCover(param) {
    if (param) {
      let title = 'Tweet do presidente';
      let message = 'Para publicar uma notícia do tipo tweet, a primeira imagem anexada se tornará a capa da publicação.\n A capa de uma publicação aparece como imagem única no feed de notícias e não é exibida na tela de detalhes da notícia.';
      let okButton = 'ok';
      let dismiss = '';
      this.alertService.activate(message, title, okButton, dismiss);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/noticias/news-form/news-form.component.ts